import {CreateSheetWithTheme, css, useTheme} from 'packages/aphrodite/aphrodite';
import Tooltip from 'packages/tooltip/Tootip.react';
import {DraftDefaultLayout} from 'src/themes/draftjs';
import {DarkTooltip} from 'src/themes/tooltip';
import {DraftLayout, DraftTheme} from './Draft.theme';
import {DraftEditorFunctions} from './DraftEditor.react';
import {Mod, ModsObject} from './Mods.react';

export default function DraftNavigation({
    editorRef,
    theme,
    layout,
    Mods,
}: {
    editorRef: React.RefObject<DraftEditorFunctions>;
    theme: DraftTheme;
    layout?: Partial<DraftLayout>;
    Mods: ModsObject;
}) {
    const Styles = useTheme(theme, StylesWithTheme, {...DraftDefaultLayout, ...(layout || {})});

    const ModClick = (mod: Mod) => (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (editorRef.current) {
            mod.onClick(editorRef.current);
        }
    };

    return (
        <nav className={css(Styles.nav)}>
            {Object.entries(Mods).map(([key, mod]) => {
                return (
                    <Tooltip
                        {...{
                            key,
                            theme: DarkTooltip,
                            content: mod.tooltip || '',
                            disabled: !mod.tooltip,
                        }}
                    >
                        <div
                            {...{
                                className: css(Styles.navItem),
                                onMouseDown: ModClick(mod),
                            }}
                        >
                            {mod.component}
                        </div>
                    </Tooltip>
                );
            })}
        </nav>
    );
}

const StylesWithTheme = CreateSheetWithTheme((theme?: DraftTheme, layout?: DraftLayout) => {
    return {
        nav: {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 10,
            background: theme?.nav_background,
            border: theme?.nav_border,
            borderBottom: theme?.nav_border_bottom,
            borderTopLeftRadius: layout?.nav_border_top_left_radius,
            borderTopRightRadius: layout?.nav_border_top_right_radius,
            borderBottomLeftRadius: layout?.nav_border_bottom_left_radius,
            borderBottomRightRadius: layout?.nav_border_bottom_right_radius,
        },
        navItem: {
            color: theme?.nav_item_color,
            margin: 3,
            padding: 3,
            cursor: 'pointer',
            background: theme?.nav_item_background,
            ':hover': {
                background: theme?.nav_item_hover_background,
            },
            ':nth-child(1n) svg': {
                display: 'block',
                fill: theme?.nav_item_color,
            },
        },
    };
});
